export default {
    total_expense: 0,
    expense: [],
    total_income: 0,
    income: [],
    total: 0,
    income_report: [],
    expense_report: []
}